<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-circle-plus-outline"
          @click="addClick"
        >
          新增
        </el-button>
        <el-button
          type="danger"
          plain
          size="mini"
          icon="el-icon-circle-close"
          @click="delClick('type', ids)"
          :disabled="ids.length < 1 ? true : false"
        >
          删除
        </el-button>
        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-top-right"
          @click="downloadClick"
          :disabled="tableData.length == 0"
        >
          导出
        </el-button>
      </div>
      <div class="search_box">
        <el-input
          class="textInput select-input"
          v-model.trim="searchParams.studentName"
          placeholder="请输入学生姓名"
          size="mini"
        ></el-input
        >&nbsp;
        <el-date-picker
          class="select-input"
          size="mini"
          v-model="searchParams.startTime"
          type="date"
          clearable
          value-format="timestamp"
          placeholder="选择开始时间"
        ></el-date-picker
        >&nbsp;
        <el-date-picker
          class="select-input"
          size="mini"
          v-model="searchParams.endTime"
          type="date"
          clearable
          value-format="timestamp"
          placeholder="选择结束时间"
        >
        </el-date-picker
        >&nbsp;
        <el-select
          class="select-input"
          v-model="searchParams.level"
          placeholder="请选择事件等级"
          size="mini"
        >
          <el-option
            v-for="(value, index) in $store.state.select.eventLevel"
            :key="index"
            :label="value.nameOne"
            :value="value.id"
          ></el-option> </el-select
        >&nbsp;
        <el-button
          size="mini"
          plain
          type="primary"
          icon="el-icon-search"
          @click="searchClick"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="tableData"
          height="100%"
          v-loading="tableLoading"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          @selection-change="selectActionData"
        >
          <el-table-column type="selection" width="40" align="center">
          </el-table-column>
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{
                searchParams.pageSize * (searchParams.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="studentName"
            label="学生姓名"
            width="120"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="className"
            label="班级名称"
            width="120"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="level"
            label="事件等级"
            width="120"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="rowData">
              {{ $store.state.select.eventLevel[rowData.row.level].nameOne }}
            </template>
          </el-table-column>
          <el-table-column
            prop="isPeculiar"
            label="是否特异体质"
            width="120"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ $store.state.select.yesOrNo[scope.row.isPeculiar].nameOne }}
            </template>
          </el-table-column>
          <el-table-column
            prop="addTime"
            label="上报时间"
            width="160"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="rowData">
              {{ $Common.dateFormatDate(rowData.row.addTime) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="happenTime"
            label="突发时间"
            width="120"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="rowData">
              {{ $Common.dateFormatDate(rowData.row.happenTime) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="results"
            label="处理结果"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="details"
            label="突发情况详情"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="editClick(scope.row)"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="delClick('single', [scope.row.id])"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchParams.pageNum"
          :page-size="searchParams.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <add-or-edit
      :drawerShow="drawerShow"
      :drawerType="drawerType"
      @handleClose="handleClose"
      @saveData="saveData"
      :initialData="addOrEditData"
    >
    </add-or-edit>
  </div>
</template>

<script>
import AddOrEditEmergency from "./components/AddOrEditEmergency";
export default {
  name: "",
  components: {
    "add-or-edit": AddOrEditEmergency
  },
  props: {},
  data() {
    return {
      searchParams: {
        schoolId: this.$store.state.schoolId,
        pageSize: 20,
        pageNum: 1,
        studentName: "",
        startTime: "",
        endTime: "",
        level: ""
      },
      responseData: {
        pageSize: 20,
        pageNum: 1,
        total: 100,
        pages: 20,
        list: []
      },

      ids: [],
      tableLoading: false,
      tableData: [],
      total: 0,
      drawerShow: false,
      drawerType: "add",
      addOrEditData: {
        id: "", //编号（编辑时传）
        studentName: "", //学校名称
        className: "", //班级名称
        isPeculiar: 0, //是否特异体质 0否 1是
        level: 0, //事件等级 0一般 1严重紧急
        results: "", //处理结果
        happenTime: "", //突发时间
        details: "", //突发情况详情
        schoolId: this.$store.state.schoolId //学校id
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 搜索按钮
    searchClick() {
      this.searchParams.pageNum = 1;
      this.getEmergencyList();
    },
    // 获取列表
    async getEmergencyList() {
      this.tableLoading = true;
      let req = Object.assign({}, this.searchParams);
      req.startTime = req.startTime ? parseInt(req.startTime) / 1000 : "";
      req.endTime = req.endTime ? parseInt(req.endTime) / 1000 : "";
      if (!req.studentName) {
        delete req.studentName;
      }
      if (!req.level) {
        delete req.level;
      }
      let res = await this.$Http.getEmergencyList(req);
      this.tableLoading = false;
      if (res.code == 200) {
        this.tableData = res.data.list || [];
        this.total = res.data.total || 0;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    selectActionData(selectData) {
      this.ids = selectData.map((item) => {
        return item.id;
      });
    },
    // 上报（新增）
    addClick() {
      this.drawerShow = true;
      this.drawerType = "add";
    },
    // 编辑
    editClick(row) {
      this.drawerShow = true;
      this.drawerType = "edit";
      this.addOrEditData = Object.assign({}, row);
      this.addOrEditData.happenTime = this.addOrEditData.happenTime * 1000;
      this.addOrEditData.schoolId = this.$store.state.schoolId;
      this.addOrEditData.happenTime = this.addOrEditData.happenTime;
    },
    // 提交数据(新增或修改)
    saveData() {
      this.drawerShow = false;
      this.getEmergencyList();
      this.refearshData();
    },
    // 关闭抽屉
    handleClose() {
      this.drawerShow = false;
      this.refearshData();
    },
    // 删除
    delClick(type, ids) {
      if (type == "all") {
        if (ids.length > 0) {
          this.deleteConfirm(ids);
        } else {
          this.$message({
            message: "请先选择所要删除的学生档案!"
          });
        }
      } else {
        this.deleteConfirm(ids);
      }
    },
    // 删除提示框
    deleteConfirm(ids) {
      this.$confirm("此操作将永久删除学生档案, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteStudentFile({ ids: ids.toString() });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    async deleteStudentFile(data) {
      let req = Object.assign({}, data);
      let res = await this.$Http.delMmergency(req);
      if (res.code == 200) {
        this.getEmergencyList();
      } else {
        this.$message({
          message: res.messsage || "删除失败",
          type: "error"
        });
      }
    },
    // 导出
    async downloadClick() {
      let req = {
        schoolId: this.$store.state.schoolId
      };
      this.$Common.exportData(req, "downloadMmergency", "突发事件记录", false);
    },
    // 刷新数据
    refearshData() {
      this.addOrEditData = {
        id: "", //编号（编辑时传）
        studentName: "", //学校名称
        className: "", //班级名称
        isPeculiar: 0, //是否特异体质 0否 1是
        level: 0, //事件等级 0一般 1严重紧急
        results: "", //处理结果
        happenTime: "", //突发时间
        details: "", //突发情况详情
        schoolId: this.$store.state.schoolId //学校id
      };
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchParams.pageNum = val || 1;
      this.getEmergencyList();
    }
  },
  created() {},
  mounted() {
    this.getEmergencyList();
  }
};
</script>

<style lang="scss" scoped>
.select-input {
  width: 152px;
}
</style>
